var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dots",staticClass:"section dots"},_vm._l((_vm.dots),function(i){return _c('span',{key:i,style:(_vm.gapStyle(i))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }